// Read a Blob's bytes without depending on Blob.prototype.arrayBuffer(), which
// Safari < 14 and Chrome < 76 don't have (V3-COMPAT-REVIEW.md F16). Falls back
// to FileReader, available in every browser the app supports.

export function readBlobBytes (blob) {
  if (typeof blob.arrayBuffer === 'function') {
    return blob.arrayBuffer().then(buffer => new Uint8Array(buffer))
  }
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(new Uint8Array(reader.result))
    reader.onerror = () => reject(reader.error)
    reader.readAsArrayBuffer(blob)
  })
}

/** The first `length` bytes only - enough to route by magic without copying the whole image. */
export function readBlobHead (blob, length) {
  return readBlobBytes(blob.slice(0, length))
}
